import React from "react";
import CommonPopModal from "../../../components/Common/commonPopModal";
import { useTranslation } from "react-i18next";

const Term = ({ setOpenTermsModal, openTermsModal }) => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`term.${key}`, { ...props });
  const i18n_common = (key, props) => t(`common.${key}`, { ...props });
  return (
    <CommonPopModal
      title={i18n_common("termsAndConditions")}
      setOpenModal={setOpenTermsModal}
    >
      <div>
        <p>{i18n("termsAndConditions.intro", { account: "用戶帳戶" })}</p>
        <p>
          {i18n("termsAndConditions.scopeAndConditions", {
            casinoName: "911win",
          })}
        </p>
        <ol>
          <li>{i18n("sections.introduction")}</li>
          <p>
            {i18n("content.introduction.companyIntro", {
              websiteLink: "https://www.911win.co/",
            })}
          </p>
          <li>{i18n("sections.partnership")}</li>
          <p>{i18n("content.partnership.rulesAndConditions")}</p>
          <li>{i18n("sections.scope")}</li>
          <p>{i18n("content.scope.conditionsIntro")}</p>
          <p>{i18n("content.scope.effectiveDate")}</p>
          <p>{i18n("content.scope.notificationOfChanges")}</p>
          <p>{i18n("content.scope.notifyingChanges")}</p>
          <p>{i18n("content.scope.fundsChangeNotification")}</p>
        </ol>
        <h2>{i18n("accountOpeningAndMaintenance.sectionTitle")}</h2>
        <div>
          <p>{i18n("accountOpeningAndMaintenance.openingAccount.point1")}</p>
          <p>{i18n("accountOpeningAndMaintenance.openingAccount.point2")}</p>
        </div>
        <div>
          <p>
            {i18n("accountOpeningAndMaintenance.accountRequirements.point3")}
          </p>
          <p>
            {i18n("accountOpeningAndMaintenance.accountRequirements.point3_1")}
          </p>
          <p>
            {i18n("accountOpeningAndMaintenance.accountRequirements.point3_2")}
          </p>
          <p>
            {i18n("accountOpeningAndMaintenance.accountRequirements.point3_3")}
          </p>
          <p>
            {i18n("accountOpeningAndMaintenance.accountRequirements.point3_4")}
          </p>
          <p>
            {i18n("accountOpeningAndMaintenance.accountRequirements.point3_5")}
          </p>
          <p>
            {i18n("accountOpeningAndMaintenance.accountRequirements.point3_6")}
          </p>
          <p>
            {i18n(
              "accountOpeningAndMaintenance.accountRequirements.point3_3_3"
            )}
          </p>
          <p>
            {i18n(
              "accountOpeningAndMaintenance.accountRequirements.point3_3_4"
            )}
          </p>
          <p>
            {i18n(
              "accountOpeningAndMaintenance.accountRequirements.point3_3_5"
            )}
          </p>
          <p>
            {i18n(
              "accountOpeningAndMaintenance.accountRequirements.point3_3_6"
            )}
          </p>
        </div>
        <p>{i18n("accountOpeningAndMaintenance.oneAccountPolicy")}</p>
        <h2>{i18n("identityVerificationAndAMLRequirements.sectionTitle")}</h2>
        <div>
          <p>
            {i18n(
              "identityVerificationAndAMLRequirements.userGuarantees.point1"
            )}
          </p>
          <p>
            {i18n(
              "identityVerificationAndAMLRequirements.userGuarantees.point1_1"
            )}
          </p>
          <p>
            {i18n(
              "identityVerificationAndAMLRequirements.userGuarantees.point1_2"
            )}
          </p>
        </div>
        <h2>{i18n("identityVerificationAndAMLRequirements.sectionTitle")}</h2>
        <div>
          <p>
            {i18n(
              "identityVerificationAndAMLRequirements.userGuarantees.point1"
            )}
          </p>
          <p>
            {i18n(
              "identityVerificationAndAMLRequirements.userGuarantees.point1_1"
            )}
          </p>
          <p>
            {i18n(
              "identityVerificationAndAMLRequirements.userGuarantees.point1_2"
            )}
          </p>
        </div>
        <div>
          <p>
            {i18n(
              "identityVerificationAndAMLRequirements.verificationAuthorization.point2"
            )}
          </p>
          <p>
            {i18n(
              "identityVerificationAndAMLRequirements.verificationAuthorization.point3"
            )}
          </p>
        </div>
        <div>
          <p>
            {i18n(
              "identityVerificationAndAMLRequirements.detailedInformationRequest.point4"
            )}
          </p>
        </div>
        <div>
          <p>
            {i18n(
              "identityVerificationAndAMLRequirements.underageUsers.point5"
            )}
          </p>
          <p>
            {i18n(
              "identityVerificationAndAMLRequirements.underageUsers.point5_1"
            )}
          </p>
          <p>
            {i18n(
              "identityVerificationAndAMLRequirements.underageUsers.point5_2"
            )}
          </p>
          <p>
            {i18n(
              "identityVerificationAndAMLRequirements.underageUsers.point5_3"
            )}
          </p>
          <p>
            {i18n(
              "identityVerificationAndAMLRequirements.underageUsers.point5_4"
            )}
          </p>
        </div>
        <h2>{i18n("userCredentialsAndInformation.sectionTitle")}</h2>
        <div>
          <p>
            {i18n("userCredentialsAndInformation.accountCredentials.point1")}
          </p>
        </div>
        <div>
          <p>{i18n("userCredentialsAndInformation.passwordChange.point2")}</p>
        </div>
        <div>
          <p>{i18n("userCredentialsAndInformation.passwordRecovery.point3")}</p>
        </div>

        <h2>{i18n("accountFunds.sectionTitle")}</h2>
        <div>
          <p>{i18n("accountFunds.depositMethods.point1")}</p>
        </div>
        <div>
          <p>{i18n("accountFunds.nonAccountHolderPayments.point2")}</p>
        </div>
        <div>
          <p>{i18n("accountFunds.sufficientFunds.point3")}</p>
        </div>
        <div>
          <p>{i18n("accountFunds.paymentRecovery.point4")}</p>
        </div>
        <div>
          <p>{i18n("accountFunds.paymentFees.point5")}</p>
        </div>
        <div>
          <p>{i18n("accountFunds.taxResponsibility.point6")}</p>
        </div>
        <div>
          <p>{i18n("accountFunds.bonusAdjustments.point7")}</p>
        </div>
        <div>
          <p>{i18n("accountFunds.accountActivity.point8")}</p>
        </div>
        <div>
          <p>{i18n("accountFunds.inactiveAccountReview.point9")}</p>
        </div>

        <h2>{i18n("betAcceptanceAndServiceUsage.sectionTitle")}</h2>
        <div>
          <p>
            {i18n("betAcceptanceAndServiceUsage.betAcceptanceRules.point1")}
          </p>
        </div>
        <div>
          <p>
            {i18n("betAcceptanceAndServiceUsage.userLocationRecording.point2")}
          </p>
        </div>
        <div>
          <p>
            {i18n("betAcceptanceAndServiceUsage.incompleteTransmission.point3")}
          </p>
        </div>
        <div>
          <p>
            {i18n(
              "betAcceptanceAndServiceUsage.betCancellationOrChange.point4"
            )}
          </p>
        </div>
        <div>
          <p>
            {i18n("betAcceptanceAndServiceUsage.suspensionOfBetting.point5")}
          </p>
        </div>
        <div>
          <p>
            {i18n(
              "betAcceptanceAndServiceUsage.accountSuspensionOrClosure.point6"
            )}
          </p>
        </div>
        <p>
          {i18n("betAcceptanceAndServiceUsage.bettingResponsibility.point7")}
        </p>
        <p>
          {i18n("betAcceptanceAndServiceUsage.lossDueToWebsiteContent.point8")}
        </p>
        <p>
          {i18n("betAcceptanceAndServiceUsage.betAcceptanceDeadline.point9")}
        </p>
        <p>{i18n("betAcceptanceAndServiceUsage.creditCardBetting.point10")}</p>
        <p>
          {i18n(
            "betAcceptanceAndServiceUsage.sufficientFundsInAccount.point11"
          )}
        </p>
        <p>{i18n("betAcceptanceAndServiceUsage.lockedOdds.point12")}</p>
        <p>
          {i18n(
            "betAcceptanceAndServiceUsage.bettingLimitsModification.point13"
          )}
        </p>

        <h2>{i18n("prohibitedActivities.point9.point1")}</h2>
        <p>{i18n("prohibitedActivities.point9_2")}</p>
        <p>{i18n("prohibitedActivities.point9_3")}</p>
        <p>{i18n("prohibitedActivities.point9_4")}</p>

        <p>{i18n("accountClosure.point10.point1")}</p>
        <p>{i18n("accountClosure.point10.point2")}</p>
        <p>{i18n("accountClosure.point10.point3")}</p>
        <p>{i18n("accountClosure.point10.point4")}</p>
        <p>{i18n("accountClosure.point10.point5")}</p>
        <p>{i18n("accountClosure.point10.point6")}</p>
        <h2>{i18n("accountSuspension.title")}</h2>
        <p>{i18n("accountSuspension.point10.point7")}</p>
        <h2>{i18n("accountSuspension.title2")}</h2>
        <p>{i18n("accountSuspension.point11.point1")}</p>
        <p>{i18n("accountSuspension.point11.point2")}</p>
        <p>{i18n("accountSuspension.point11.point3")}</p>
        <p>{i18n("accountSuspension.point11.point4")}</p>
        <p>{i18n("accountSuspension.point11.point5")}</p>

        <p>{i18n("itFailure.point12.point1")}</p>
        <p>{i18n("itFailure.point12.point2")}</p>
        <p>{i18n("itFailure.point12.point2_subPoints")}</p>
        <p>{i18n("itFailure.point12.point3")}</p>
        <p>{i18n("itFailure.point12.point3_subPoints")}</p>
        <p>{i18n("itFailure.point12.point4")}</p>
        <p>{i18n("itFailure.point12.point5")}</p>
        <p>{i18n("itFailure.point12.point6")}</p>
        <p>{i18n("itFailure.point12.point7")}</p>

        {/* <h2>{i18n("forceMajeure.point13")}</h2> */}
        <p>{i18n("forceMajeure.point13.point1")}</p>
        <p>{i18n("forceMajeure.point13.point2")}</p>
        <p>{i18n("forceMajeure.point13.point3")}</p>

        {/* <h2>{i18n("forceMajeure.point14")}</h2> */}
        <p>{i18n("forceMajeure.point14.point1")}</p>
        <p>{i18n("forceMajeure.point14.point2")}</p>

        {/* <h2>{i18n("claimsAndDisputes.point15")}</h2> */}
        <p>{i18n("claimsAndDisputes.point15.point1")}</p>
        <p>{i18n("claimsAndDisputes.point15.point2")}</p>
        <p>{i18n("claimsAndDisputes.point15.subPoints")}</p>
        <p>{i18n("claimsAndDisputes.point15.point3")}</p>
        <p>{i18n("claimsAndDisputes.point15.point4")}</p>
        {/* <h2>{i18n("complaints.point16")}</h2> */}
        <p>{i18n("complaints.point16.point1")}</p>
        <p>{i18n("complaints.point16.point2")}</p>
        <p>{i18n("complaints.point16.point3")}</p>

        {/* <h2>{i18n("rulesAndTerms.point17")}</h2> */}
        <p>{i18n("rulesAndTerms.point17.point1")}</p>

        {/* <h2>{i18n("rulesAndTerms.point18")}</h2> */}
        <p>{i18n("rulesAndTerms.point18.point1")}</p>
        <p>{i18n("rulesAndTerms.point18.point2")}</p>
        <p>{i18n("rulesAndTerms.point18.point3")}</p>

        {/* <h2>{i18n("cookiesUsage.point19")}</h2> */}
        <p>{i18n("cookiesUsage.point19.point1")}</p>

        {/* <h2>{i18n("noWarranty.point20")}</h2> */}
        <p>{i18n("noWarranty.point20.point1")}</p>
        <p>{i18n("noWarranty.point20.point2")}</p>
        <p>{i18n("noWarranty.point20.point3")}</p>

        {/* <h2>{i18n("limitationOfLiability.point21")}</h2> */}
        <p>{i18n("limitationOfLiability.point21.point1")}</p>
        <p>{i18n("limitationOfLiability.point21.point2")}</p>
        <p>{i18n("limitationOfLiability.point21.point3")}</p>
        <p>{i18n("limitationOfLiability.point21.point4")}</p>
        <p>{i18n("limitationOfLiability.point21.point5")}</p>
        <p>{i18n("limitationOfLiability.point21.point6")}</p>

        {/* <h2>{i18n("indemnification.point22")}</h2> */}
        <p>{i18n("indemnification.point22.point1")}</p>
        {/* <h2>{i18n("applicableLawsAndJurisdiction.point23")}</h2> */}
        <p>{i18n("applicableLawsAndJurisdiction.point23.point1")}</p>

        {/* <h2>{i18n("intellectualProperty.point24")}</h2> */}
        <p>{i18n("intellectualProperty.point24.point1")}</p>
        <p>{i18n("intellectualProperty.point24.point2")}</p>
        <p>{i18n("intellectualProperty.point24.point3")}</p>

        {/* <h2>{i18n("responsibleGambling.point25")}</h2> */}
        <p>{i18n("responsibleGambling.point25.point1")}</p>
        <p>{i18n("responsibleGambling.point25.point2")}</p>
        <p>{i18n("responsibleGambling.point25.point3")}</p>

        <h2>{i18n("contactUs.point26")}</h2>
        <p>{i18n("contactUs.point26.point1")}</p>
        <h2>{i18n("definitions.userAccountOrAccount")}</h2>
        <p>{i18n("definitions.userAccountOrAccount")}</p>

        <p>{i18n("definitions.betting")}</p>

        <p>{i18n("definitions.company")}</p>

        <p>{i18n("definitions.content")}</p>

        <p>{i18n("definitions.intellectualProperty")}</p>

        <p>{i18n("definitions.privacyPolicy")}</p>

        <p>{i18n("definitions.rules")}</p>

        <p>{i18n("definitions.service")}</p>

        <p>{i18n("definitions.software")}</p>

        <p>{i18n("definitions.terms")}</p>
      </div>
    </CommonPopModal>
  );
};

export default Term;
